module.exports = "<router-outlet></router-outlet>\n<app-message-overlay *ngIf=\"!isLandscapeEnabled()\" class=\"u-hide-portrait u-hide-md u-hide-notouch\"></app-message-overlay>\n\n<app-splash-page *ngIf=\"LayoutService.showSplashscreen\"></app-splash-page>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main